export const stringToNumber = (string: string) => {
  if (string.includes('K')) {
    return Number(string.replace('K', '')) * 1000;
  }
  if (string.includes('M')) {
    return Number(string.replace('M', '')) * 1000000;
  }
  if (string.includes('B')) {
    return Number(string.replace('B', '')) * 1000000000;
  }
  return Number(string);
};

/**
 * Converts a number to formatted Number
 * e.g 4566789 => 4,566,789.00
 * @param numberString Number in string
 * @param decimalPlaces decimal places to display
 * @returns
 */
export const stringToFormattedNumber = (
  numberString: string,
  decimalPlaces: number = 2,
  minimumDecimal: number | undefined = undefined,
  maximumDecimal: number | undefined = undefined,
) => {
  return Number(numberString).toLocaleString('en-US', {
    useGrouping: true, // Adds commas as thousands separators
    minimumFractionDigits:
      minimumDecimal !== undefined ? minimumDecimal : decimalPlaces, // Specifies minimum decimal places
    maximumFractionDigits:
      maximumDecimal !== undefined ? maximumDecimal : decimalPlaces, // Specifies maximum decimal places
  });
};
